export const isTruthy = <T>(n: T | void | null | undefined | false | 0 | ''): n is T => Boolean(n);
